import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography, Button, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  code: {
    fontSize: '6rem',
    fontWeight: 800,
    fontFamily: '"TWK Everett", sans-serif',
    color: theme.palette.primary.main,
    lineHeight: 1,
    marginBottom: theme.spacing(1),
  },
  message: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
    maxWidth: 420,
  },
}));

export const KyndrylNotFoundPage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.code}>404</Typography>
      <Typography className={classes.message}>Page not found</Typography>
      <Typography className={classes.subtitle}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        size="large"
      >
        Return to dashboard
      </Button>
    </Box>
  );
};

export const KyndrylBootErrorPage = ({
  step,
  error,
}: {
  step: string;
  error: Error;
}) => {
  const classes = useStyles();
  const theme = useTheme();

  let message = 'An unexpected error occurred.';
  if (step === 'load-config') {
    message = 'Failed to load configuration. Please contact your platform team.';
  } else if (step === 'load-chunk') {
    message = 'Failed to load a required module. Try refreshing the page.';
  }

  return (
    <Box className={classes.root}>
      <Typography className={classes.code}>Error</Typography>
      <Typography className={classes.message}>{message}</Typography>
      <Typography
        className={classes.subtitle}
        style={{ fontFamily: 'monospace', fontSize: '0.8rem', color: theme.palette.error.main }}
      >
        {error.message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => window.location.reload()}
      >
        Reload page
      </Button>
    </Box>
  );
};
